import { CommonGet, CommonPost, CommonGetIDServer, CommonPostIDServer } from "../../../utils/CommonFetch";

export default {
    GetAllCollectionPoints,
    getAllOperationEntitiesForDropDown,
    getOperationEntityByID,
    getOperationProductFilterData,
    AddOperationEntityProductMapping,
    getAvialableProducts,
    EditOperationEntityProductMapping,
    getUnsusedProducts
};

async function getOperationProductFilterData(data) {
    var filterModel = {
        operationEntityID: data.operationEntityID,
        productID: data.productID,
    }
    const response = await CommonPost('/api/OperationentityProductMapping/FilterOperationEntityProducts', null, filterModel);
    return response.data;
}

async function AddOperationEntityProductMapping(data) {
    let operationEntityProduct = {
        operationEntityProductID: 0,
        operationEntityID: parseInt(data.operationEntityID),
        productID: parseInt(data.productID),
        isActive: data.isActive,
        createdBy: 0,
        createdDate: new Date().toISOString(),
        modifiedBy: 0,
        modifiedDate: new Date().toISOString()
    }
    var response = await CommonPost('/api/OperationentityProductMapping/AddOperationEntityProduct', null, operationEntityProduct);
    return response;
}

async function EditOperationEntityProductMapping(operationEntityProductID) {
    var response = await CommonGet('/api/OperationentityProductMapping/UpdateOperationEntityProduct', 'operationEntityProductID=' + operationEntityProductID);
    return response;
}

async function GetAllCollectionPoints(id, groupID) {
    var collectionPointArray = [];
    const response = await CommonGet('/api/CollectionPoint/GetAllCollectionPoint', null);
    for (let item of Object.entries(response.data)) {
        if(item[1] !== undefined && item[1]["operationEntityID"] === id && item[1]["groupID"] === parseInt(groupID) && item[1]["isActive"] === true) {
                collectionPointArray[item[1]["collectionPointID"]] = item[1]["collectionPointName"]
        }
    }
    return collectionPointArray;
}

async function getAllOperationEntitiesForDropDown(id) {
    var operationEntityArray = [];
    var response = await CommonGet('/api/OperationEntity/GetAllOperationEntities', null);
    for (let item of Object.entries(response.data)) {
        if (item[1] !== undefined && item[1]["groupID"] === parseInt(id) && item[1]["isActive"] === true)
            operationEntityArray[item[1]["operationEntityID"]] = item[1]["operationEntityName"];
    }
     return operationEntityArray;
}

async function getOperationEntityByID(operationEntityID) {
    var response = await CommonGet('/api/OperationEntity/GetOperationEntityByID', 'operationEntityID=' + operationEntityID);
    return response.data;
}

async function getAvialableProducts(operationEntityID){
    var productsArray = [];
    var response = await CommonGet('/api/Product/GetProductsOfOperationEntity','operationEntityID=' + operationEntityID);
    for (let item of Object.entries(response.data)) {
            productsArray[item[1]["productID"]] = item[1]["productName"];
    }
    return productsArray;
}

async function getUnsusedProducts(operationEntityID){
    var productsArray = [];
    var response = await CommonGet('/api/Product/GetUnusedProductsOfOperationEntity','operationEntityID=' + operationEntityID);
    for (let item of Object.entries(response.data)) {
            productsArray[item[1]["productID"]] = item[1]["productName"];
    }
    return productsArray;
}